import React from "react"
import { useDispatch, useSelector } from "react-redux"
import Modal from "../../../components/Modal"
import LoginSection from "./LoginSection"
import SignUpSection from "./SignUpSection"
import { setOpenLoginModal, setOpenSignUpModal } from "../../../redux/userSlice"
import KYCModal from "./KYCModal"

const OnBoardingModule = () => {
  const dispatch = useDispatch()
  const state = useSelector((state) => state)
  const { openKYCModal, openLoginModal, openSignupModal } = state.user
  const toggleSignUpLoginModal = () => {
    dispatch(setOpenLoginModal(!openLoginModal))
    dispatch(setOpenSignUpModal(!openSignupModal))
  }

  return (
    <>
      {openLoginModal ? (
        <LoginSection
          isOpen={openLoginModal}
          toggleSignUpLoginModal={toggleSignUpLoginModal}
          onPressClose={() => dispatch(setOpenLoginModal(false))}
        />
      ) : null}

      {openSignupModal ? (
        <Modal
          visible={openSignupModal}
          onClose={() => dispatch(setOpenSignUpModal(!openSignupModal))}
        >
          <div className="w-[1080px] h-[720px] bg-gradient-to-b from-[#9BD7D0] from-0%  to-[#FFFFFF] to-50% rounded-[24px] overflow-hidden">
            <SignUpSection toggleSignUpLoginModal={toggleSignUpLoginModal} />
          </div>
        </Modal>
      ) : null}

      {openKYCModal ? <KYCModal /> : null}
    </>
  )
}

export default OnBoardingModule
